import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["dragContainer"];

  connect() {
    const dragula = require("dragula");

    // Single mechanism for create & update
    // Always rely on hidden "position" inputs, never call server
    this.isNew = this.element.dataset.new === "true";

    // Main container
    this.container =
      this.dragContainerTargets[0] ||
      this.element.querySelector(".field-options-list");

    if (!this.container) {
      console.warn("Drag controller: container not found");
      return;
    }

    // Initialize dragula
    this.drake = dragula({
      containers: [this.container],
      invalid: (el, handle) => {
        if (!handle) return true;

        // Only draggable when starting from a .drag-handle
        if (
          !handle.closest(".drag-handle") &&
          !handle.closest("[data-drag-handle]")
        ) {
          return true;
        }

        // Prevent dragging from form inputs
        const tag = handle.tagName;
        if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") {
          return true;
        }

        return false;
      },
    });

    this.drake.on("drag", this.onDragStart.bind(this));
    this.drake.on("dragend", this.onDragEnd.bind(this));
    this.drake.on("drop", this.changePosition.bind(this));

    // Observe dynamic additions/removals
    this.observer = new MutationObserver((mutations) => {
      let changed = false;

      for (const m of mutations) {
        if (m.type === "childList" && (m.addedNodes.length || m.removedNodes.length)) {
          changed = true;
          break;
        }
      }

      if (changed) {
        // Let DOM settle, then update
        setTimeout(() => this.updateDOMPositions(this.container), 0);
      }
    });

    this.observer.observe(this.container, { childList: true });

    // Set initial positions when loads
    this.updateDOMPositions(this.container);
  }

  disconnect() {
    try {
      this.drake?.destroy();
    } catch (_) {}

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    document.body.classList.remove("dragging");
  }

  onDragStart() {
    document.body.classList.add("dragging");
  }

  onDragEnd() {
    document.body.classList.remove("dragging");
  }

  changePosition(el, target) {
    if (!target) return;

    // ALWAYS update hidden position fields
    this.updateDOMPositions(target);
  }

  updateDOMPositions(target) {
    if (!target) return;

    const blocks = Array.from(
      target.querySelectorAll("[data-block-option-id]")
    );

    if (!blocks.length) return;

    blocks.forEach((block, index) => {
      const input = block.querySelector(".position-field");
      if (!input) return;

      input.value = String(index + 1);
    });
  }
}
